import * as React from 'react';
import cx from 'classnames';
import styles from './StrongAuth.css';
import debounce from 'lodash/debounce';
import { stringTemplate } from 'components/StringWidget/StringWidget';
import Button from 'components/Button/Button';
import OtpInput from 'components/OtpInput/OtpInput';
import OtpTimer from './OtpTimer/OtpTimer';
import { AsyncStatus } from 'utils/asyncStatusHelper';
class StrongAuth extends React.Component {
    constructor(props) {
        super(props);
        this.onResetOtpHandler = () => {
            // Clear the otp field if resend otp is called;
            // The reason for incrementing the otpInputKey is to rerender the OtpInput component
            // which initialises the defaultValue set as a prop in the constructor, this helps in
            // clearing the input fields.
            this.setState(prevState => {
                return {
                    otp: '',
                    otpInputKey: prevState.otpInputKey + 1
                };
            }, () => {
                this.props.onResendOtp();
            });
        };
        this.handleOnVerifyOtp = (otp) => () => {
            this.deboucedOnSubmitOtp(otp);
        };
        this.handleOTPChange = value => {
            if (value) {
                this.setState({
                    otp: value.join('')
                });
            }
        };
        this.state = {
            isOtpOverlayVisible: true,
            otp: '',
            otpInputKey: 0
        };
        // Although loader state is present during API call which disables the VerifyOtp Button,
        // however as the network call resolves quickly. Hence, on clicking the button multiple times really
        // fast, the toast seemed to stop coming all together. Deboucing prevents multiple calls thus preventing
        // the toast to open frequently.
        this.deboucedOnSubmitOtp = debounce(this.props.onSubmitOtp, 500);
    }
    componentDidMount() {
        this.props.generateOtp();
    }
    render() {
        const { otp, otpInputKey } = this.state;
        const { isResendOtpEnabled = false, isOtpTimerVisible = false, disableOtpTimer, userId = '', numberOfInputs = 6, isVerifyInfoVisible = false, generateOtpState, verifyOtpState, titleInfoText, titleInfoTextParams, verifyInfoTitle, verifyInfoBodyText } = this.props;
        const titleInfoMessage = {
            success: stringTemplate(titleInfoText, titleInfoTextParams),
            error: stringTemplate('titleInfoMessageError')
        };
        const verifyInfoTitleText = verifyInfoTitle || stringTemplate('verifyInfoTitleText');
        const verifyInfoTitleBodyText = verifyInfoBodyText || stringTemplate('verifyInfoTitleBodyText');
        const resendOTPText = stringTemplate('resendOTP');
        const otpNotReceivedText = stringTemplate('otpNotReceivedText');
        const verifyButtonText = stringTemplate('loginVerifyBtnTxt');
        const generatingOTPText = stringTemplate('generateOtpText');
        return (<div className={styles['strong-auth-container']}>
				{isVerifyInfoVisible && (<div className={styles['verify-info-container']}>
						<div className={styles['verify-info-title']}>{verifyInfoTitleText}</div>
						<div className={styles['verify-info-body']}>{verifyInfoTitleBodyText}</div>
					</div>)}
				<div className={styles['otp-content']}>
					{generateOtpState === AsyncStatus.LOADING ? (<div className={styles['title-info']}>{generatingOTPText}</div>) : (<p className={styles['title-info']}>
							{generateOtpState === AsyncStatus.SUCCESS ? (<React.Fragment>
									{titleInfoMessage.success}
									{!!userId && <span className={styles['otp-phone-number']}>{userId}</span>}
								</React.Fragment>) : (<React.Fragment>{titleInfoMessage.error}</React.Fragment>)}
						</p>)}
					<div className={styles['otp-field-container']}>
						<OtpInput key={otpInputKey} onChange={this.handleOTPChange} inputWrapperClass={styles['input-wrapper']} inputClass={styles['input']} defaultValue={[]}/>
					</div>
					<Button className={styles['verify-otp-btn']} primary onClick={this.handleOnVerifyOtp(otp)} disabled={verifyOtpState === AsyncStatus.LOADING || otp.length < numberOfInputs}>
						{verifyButtonText}
					</Button>
					<div className={styles['otp-bottom-info']}>
						<div className={styles['resend-otp-container']}>
							{`${otpNotReceivedText} `}
							<Button className={cx(styles['resend-otp-btn'], isResendOtpEnabled ? (!(generateOtpState === AsyncStatus.LOADING) ? styles['active'] : '') : '')} onClick={this.onResetOtpHandler} disabled={generateOtpState === AsyncStatus.LOADING || !isResendOtpEnabled}>
								{resendOTPText}
							</Button>
						</div>
						{isOtpTimerVisible && <OtpTimer disableOtpTimer={disableOtpTimer}/>}
					</div>
				</div>
			</div>);
    }
}
export default StrongAuth;
